module.exports = __webpack_public_path__ + "static/media/tusd.677b9a0d.svg";